import { localizeEventCityForLanguage } from "./eventLocation";
import { getProfileCountry } from "../../constants/profileLocations";

export function getEventCountryValue(marketRegion = "EU", homeCountry = "") {
  if (String(marketRegion || "").trim().toUpperCase() === "RU") return "Russia";
  const country = getProfileCountry(homeCountry);
  return country && country.value !== "RU" ? country.label : "Slovakia";
}

export function getEventCountryDisplayLabel(t, marketRegion = "EU", homeCountry = "") {
  const isRussianRegion = String(marketRegion || "").trim().toUpperCase() === "RU";
  const country = getEventCountryValue(marketRegion, homeCountry);
  if (!isRussianRegion && country !== "Slovakia") return country;
  return t(
    isRussianRegion ? "filters.geo.countries.russia" : "filters.geo.countries.slovakia",
    { defaultValue: isRussianRegion ? "Russia" : "Slovakia" }
  );
}

// Kept as a compatibility export for older callers outside the event filter.
export const getEventRegionDisplayLabel = getEventCountryDisplayLabel;

export function getEventCityDisplayLabel(t, city, marketRegion = "EU") {
  const cityName = String(city || "").trim();
  if (String(marketRegion).toUpperCase() === "RU") {
    return localizeEventCityForLanguage(cityName, "ru");
  }
  const normalizedCity = cityName.toLowerCase();
  if (normalizedCity === "yekaterinburg" || normalizedCity === "екатеринбург") {
    return t("filters.geo.cities.yekaterinburg", { defaultValue: cityName });
  }
  if (normalizedCity === "moscow" || normalizedCity === "москва") {
    return t("filters.geo.cities.moscow", { defaultValue: cityName });
  }
  return cityName;
}
